import { post } from "../../Http";
import {financeJournalLv} from "../../config";

// 获取个性化设置
function configBaseQueryById(user) {
  return post(`/${financeJournalLv}/configbase/queryById`, {});
}
// 更新个性化设置
function configBaseUpdate(params) {
  return post(`/${financeJournalLv}/configbase/update`, params)
}

export default {
  configBaseQueryById,
  configBaseUpdate
}



// WEBPACK FOOTER //
// ./src/api/finance-account/finance-account-setting/PersonalizeSettingApi.js